__turbopack_context__.v({
  "accountBtn": "EyoBoG_accountBtn",
  "accountError": "EyoBoG_accountError",
  "accountGreeting": "EyoBoG_accountGreeting",
  "accountIcon": "EyoBoG_accountIcon",
  "accountWrapper": "EyoBoG_accountWrapper",
  "bg": "EyoBoG_bg",
  "brand": "EyoBoG_brand",
  "center": "EyoBoG_center",
  "end": "EyoBoG_end",
  "header": "EyoBoG_header",
  "inner": "EyoBoG_inner",
  "searchField": "EyoBoG_searchField",
  "searchIcon": "EyoBoG_searchIcon",
  "searchRow": "EyoBoG_searchRow",
  "searchRowInner": "EyoBoG_searchRowInner",
  "start": "EyoBoG_start",
  "transparent": "EyoBoG_transparent",
});
